<div class="fab-backdrop" *ngIf="open" (click)="close()"></div>

<div class="fab-container">
  <div class="fab-actions" [class.open]="open">
    <button type="button" class="fab-action" (click)="startSurvey()">
      {{ 'dashboard.fab.start_survey' | translate }}
    </button>
    <button type="button" class="fab-action" (click)="enterWeight()">
      {{ 'dashboard.fab.enter_weight' | translate }}
    </button>
    <button type="button" class="fab-action" (click)="addMeal()">
      {{ 'dashboard.fab.add_meal' | translate }}
    </button>
  </div>

  <button
    type="button"
    class="fab-main"
    [class.open]="open"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [attr.aria-label]="'dashboard.fab.toggle' | translate"
  >
    <span class="fab-main__icon" aria-hidden="true">+</span>
  </button>
</div>
